import {COMMUNITY} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/share'
import {push} from 'react-router-redux'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import withOthersActions from './withOthers'
import {endpoint as endpointText} from '../../../common/text'
import {share as text} from '../text'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class share {

  static setOpen(open) {
    return {
      type: types.SET_OPEN,
      payload: {
        open,
      },
    }
  }

  static setEmail(email) {
    return {
      type: types.SET_EMAIL,
      payload: {
        value: email,
      },
    }
  }

  static share() {
    return function(dispatch, getState) {

      const state = getState().ui.shared.share
      const email = state.getIn(['email', 'value'])

      if (email === '') {
        dispatch(share.shareFail(''))
        return
      }

      dispatch({type: types.SHARE})

      const data = new FormData()
      data.append('requester', email)

      apiPrivate.post(`${COMMUNITY}/catalogPermission`, data)
        .then(response => {
          dispatch(share.shareSuccess())
          dispatch(simpleSnackbarActions.showMessage(text.actions.success))
          dispatch(withOthersActions.fetch())
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(share.shareFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(share.shareFail(message))
        })
    }
  }

  static shareSuccess(data) {
    return {
      type: types.SHARE_SUCCESS,
    }
  }

  static shareFail(error) {
    return {
      type: types.SHARE_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/shared/actions/share.js